import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChoiceRow, EntryLayout } from '../../components/EntryLayout';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import type { Locale } from '../../types';

/** MOB/Auth/Language — writes straight into the centralized i18n system. */
export function LanguageSelect() {
  const {
    t,
    locale,
    source,
    setLocale
  } = useLocale();
  const navigate = useNavigate();
  const options: {
    id: Locale;
    label: string;
    hint: string;
  }[] = [{
    id: 'pt-BR',
    label: t('entry.lang.ptBR'),
    hint: t('entry.lang.ptBR.hint')
  }, {
    id: 'en-US',
    label: t('entry.lang.enUS'),
    hint: t('entry.lang.enUS.hint')
  }];
  return <EntryLayout title={t('entry.lang.title')} body={t('entry.lang.body')} showBack={false} footer={<Button variant="gold" size="lg" fullWidth onClick={() => navigate('/entrar')} data-id="element-2377" data-mp="318z6sup87gbd">
          {t('entry.lang.continue')}
        </Button>} data-id="element-2376" data-mp="2djo7lhnixtzc">
      <ul className="space-y-2" data-id="element-2378" data-mp="3e777q6h3fbht">
        {options.map(option => <li key={option.id} data-id="element-2379" data-mp="398xcjvvdcaw7">
            <ChoiceRow label={option.label} hint={option.hint} selected={locale === option.id} onClick={() => setLocale(option.id)} data-id="element-2380" data-mp="399oy0dv94s8r" />
          </li>)}
      </ul>
      {source === 'system' && <p className="mt-2 px-1 text-[11.5px] leading-snug text-muted" data-id="element-2381" data-mp="t3wfi4y91fo">
          {t('entry.lang.detected')}
        </p>}
    </EntryLayout>;
}